import { Shield, AlertTriangle, X } from "lucide-react";

export const COMMUNITY_RULES = [
  { icon: "🚫", title: "Keine Beleidigungen", desc: "Respektvoller Umgang ist Pflicht. Persönliche Angriffe, Hass oder Diskriminierung führen zu sofortiger Verwarnung." },
  { icon: "📵", title: "Kein Spam", desc: "Keine Werbung, keine Massennachrichten, keine Off-Topic-Posts. Inhalte müssen für Fahrzeugüberführer relevant sein." },
  { icon: "⚠️", title: "3-Verwarnungs-System", desc: "Bei 3 Verstößen wird dein Konto automatisch gesperrt. Beleidigende Nachrichten werden gar nicht erst veröffentlicht." },
  { icon: "🤝", title: "Hilfsbereitschaft", desc: "Wir sind eine Community. Hilf Kollegen mit Rat, Erfahrung und Tipps – wie du es selbst dir wünschst." },
  { icon: "🔐", title: "Privatsphäre", desc: "Teile keine privaten Daten anderer ohne Erlaubnis. Keine Fotos von Fahrzeugen mit lesbaren Kennzeichen." },
  { icon: "💼", title: "Marktplatz fair", desc: "Im Marktplatz-Kanal nur seriöse Angebote und Aufträge. Keine Lockangebote, kein Schwarzmarkt." },
  { icon: "📷", title: "Bilder", desc: "Nur Bilder, die für die Community relevant sind. Keine anstößigen, gewaltverherrlichenden oder pornografischen Inhalte." },
  { icon: "👮", title: "Rechtskonformität", desc: "Halte dich an deutsche, österreichische und schweizerische Gesetze. Diskussionen über illegale Aktivitäten werden gemeldet." },
];

export default function RulesModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="rules-modal-overlay"
    >
      <div
        className="bg-[#FFFFFF] border border-slate-200 rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
        data-testid="rules-modal"
      >
        <div className="flex items-center justify-between p-5 border-b border-slate-200">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-[#1D5BFF]/15 border border-[#1D5BFF]/30 flex items-center justify-center">
              <Shield className="w-5 h-5 text-[#4DBFFF]" />
            </div>
            <div>
              <h2 className="font-display text-xl font-black text-slate-900 tracking-tighter">Community-Regeln</h2>
              <p className="text-xs text-slate-600">TSU-PARTNERS · Verhaltenskodex</p>
            </div>
          </div>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-slate-100/70 text-slate-600" data-testid="rules-close-btn">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-5 space-y-3">
          <div className="bg-amber-500/10 border border-amber-500/30 rounded-xl p-4 flex gap-3 items-start">
            <AlertTriangle className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" />
            <p className="text-sm text-amber-100">
              Dieses Portal ist ausschließlich für aktive Fahrzeugüberführer.
              Die Freischaltung erfolgt nur nach Anmeldung beim WhatsApp-Agenten.
              Verstöße werden konsequent geahndet.
            </p>
          </div>

          {COMMUNITY_RULES.map((r, i) => (
            <div key={i} className="bg-[#F5F8FD] border border-slate-200/60 rounded-xl p-4 flex gap-3">
              <div className="text-2xl shrink-0" aria-hidden>{r.icon}</div>
              <div>
                <div className="font-display font-bold text-slate-900">{r.title}</div>
                <div className="text-sm text-slate-600 mt-0.5">{r.desc}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="p-5 border-t border-slate-200 bg-[#F5F8FD]">
          <button
            onClick={onClose}
            data-testid="rules-acknowledge-btn"
            className="w-full bg-[#1D5BFF] hover:bg-[#1546C9] text-white font-bold py-3 rounded-full transition-all active:scale-95"
          >
            Verstanden – zurück zur Registrierung
          </button>
        </div>
      </div>
    </div>
  );
}
